import { NewThemeFields, upsertThemeGQLMutation } from '../../graphql/index.js'
import { MutationUpsertThemeArgs, NewTheme } from '../../types/index.js'
import { GraphqlClient } from '../graphql.client.js'

export class ThemeClient {
  private client: GraphqlClient

  constructor(client: GraphqlClient) {
    this.client = client
  }

  async upsert(
    variables: MutationUpsertThemeArgs,
    fields: NewThemeFields = 'basic',
    accessToken?: string,
  ): Promise<NewTheme> {
    type QueryResult = { upsertTheme: NewTheme }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: upsertThemeGQLMutation(fields),
      variables,
      customToken: accessToken,
    })
    return result.upsertTheme
  }
}
